import { Box, FormControlLabel } from '@mui/material';
import { useTheme } from '@mui/styles';
import { DownloadOption } from 'types';
import { FormControl } from './components/FormControl';
import Label from './components/Label';
import RadioTitle from './components/RadioTitle';
import UpgradeButton from './components/UpgradeButton';
import { useBorderColor } from './styles';

interface RadioButtonProps {
  downloadOption: DownloadOption;
  isLocked?: boolean;
  isSelected: boolean;
  onClick: () => void;
  labelText?: string;
}

export const RadioButton = ({
  downloadOption,
  isLocked,
  isSelected,
  onClick,
  labelText,
}: RadioButtonProps) => {
  const theme = useTheme();

  const borderColor = useBorderColor(isSelected, isLocked);

  const handleOnClick = () => {
    if (isLocked) return;

    onClick();
  };

  const cursor = isLocked ? 'not-allowed' : 'pointer';

  return (
    <Box
      data-testid={`radio-button-${downloadOption}`}
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderColor,
        cursor,
        backgroundColor: isSelected ? theme.palette.grey[50] : undefined,
        justifyContent: 'space-between',
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: 4,
        flexDirection: 'row',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
      }}
      onClick={handleOnClick}
    >
      <Box>
        <FormControlLabel
          control={<FormControl isLocked={isLocked} isSelected={isSelected} />}
          label={
            <RadioTitle
              downloadOption={downloadOption}
              isSelected={isSelected}
            />
          }
          sx={{
            cursor,
            color: isLocked ? theme.palette.grey[400] : theme.palette.grey[900],
          }}
          aria-checked={isSelected}
        />
      </Box>
      {isLocked && <UpgradeButton />}
      {labelText && !isLocked && <Label labelText={labelText} />}
    </Box>
  );
};
